import { useState } from 'react'

import styles from './Block.module.css'
import BlockArrow from './BlockArrow'
import BlockImage from './BlockImage'

interface BlockProps {
  id: string
  images: string[]
  height: number
}

export default function Block(props: BlockProps) {
  const [selected, setSelected] = useState(Math.floor(Math.random() * props.images.length))
  
  const increase = () => setSelected((selected + 1) % props.images.length)
  const decrease = () => {
    var n = selected - 1;
    if (n < 0) {
      n = props.images.length - 1;
    }

    setSelected(n);
  }

  return <div className={styles.block} style={{ height: props.height }}>
    <BlockArrow direction='left' onClick={() => increase()}/>
    <BlockImage src={props.images[selected]} />
    <BlockArrow direction='right' onClick={() => decrease()}/>
  </div>
}